// extracted by css-extract-rspack-plugin
export default {"BulletList":"BulletList-J4vToO","bulletList":"BulletList-J4vToO","BulletListItem":"BulletListItem-Z6vEHo","bulletListItem":"BulletListItem-Z6vEHo"};